<block-ui></block-ui>
  <div class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-body">
        <ul ngbNav #nav="ngbNav" class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
          <li ngbNavItem class="nav-item mt-2">
            <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="getDetails()">{{utilityService.getResourceValue("Details")}}</a>
            <ng-template ngbNavContent>
              <div class="card">
                <div class="card-header border-0 pt-5 px-0  justify-content-end">
                  <div class="card-toolbar">
                    <button type="button" *ngIf="WorkflowDetails.isPublished"
                            id="btnPublish" class="btn btn-sm btn-primary">
                      {{utilityService.getResourceValue("PublishWorkflow")}}

                    </button>
                    <!--<a class="btn btn-sm btn-light-primary">
                      {{utilityService.getResourceValue("Preview")}}
                    </a>-->

                  </div>
                </div>
                <div class="card-body py-3 px-0">
                  <form [formGroup]="DetailsForm" *ngIf="ShowWorkflowDetails">
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-MultiLingualTextBox [options]="NameMultilingualTextBox"
                                                  [group]="DetailsForm">
                        </BBSF-MultiLingualTextBox>
                        <div class="col-md-12">
                          <BBSF-MultiLingualTextBox [options]="DescriptionMultilingualTextBox"
                                                    [group]="DetailsForm">
                          </BBSF-MultiLingualTextBox>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="SysName"
                                      [group]="DetailsForm">
                        </BBSF-TextBox>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="label-content">
                            <BBSF-TextBox [options]="Active"
                                          [group]="DetailsForm">
                            </BBSF-TextBox>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="label-content">
                            <BBSF-TextBox [options]="Published"
                                          [group]="DetailsForm">
                            </BBSF-TextBox>
                          </div>
                        </div>

                      </div>
                    </div>


                  </form>


                </div>
                <!--end:: Widgets/Applications/User/Profile3-->
              </div>
            </ng-template>
          </li>
          <li ngbNavItem class="nav-item mt-2">
            <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="GetVersions()">{{utilityService.getResourceValue("Versions")}}</a>
            <ng-template ngbNavContent>
              <div class="card">
                <div class="card-header border-0 pt-5 px-0">
                  <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
                    <form [formGroup]="WorkflowActivityForm">
                      <BBSF-TextBox [options]="searchTextBox" [group]="WorkflowActivityForm"></BBSF-TextBox>
                      <BBSF-TextBox [options]="WorkflowIdTextBox"
                                    [group]="WorkflowActivityForm" [hidden]="true"></BBSF-TextBox>
                    </form>
                  </div>
                </div>
                <div class="card-body py-3 px-0">
                  <!--begin::Permission list-->
                  <div class="table-responsive">
                    <!-- begin::Table -->
                    <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                      <thead>
                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                          <th class="min-w-150px">{{utilityService.getResourceValue("Change")}}</th>
                          <th class="min-w-150px">{{utilityService.getResourceValue("Current")}}</th>
                          <th class="min-w-150px">{{utilityService.getResourceValue("Published")}}</th>
                          <th class="min-w-150px">{{utilityService.getResourceValue("CreationDate")}}</th>
                        </tr>
                      </thead>
                      <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
                        <tr *ngFor="let Activity of WorkflowActivityPagingResult">
                          <td>
                            <a *ngIf="language=='en'" href="javascript:void(0)"
                               [routerLink]="['/Admin/Workflows/tabs',Activity.id]"
                               routerLinkActive="router-link-active"
                               class="text-dark">{{Activity.change.current}}</a>
                            <a *ngIf="language=='ar'" href="javascript:void(0)"
                               [routerLink]="['/Admin/Workflows/tabs',Activity.id]"
                               routerLinkActive="router-link-active"
                               class="text-dark">{{Activity.change.current}}</a>
                          </td>
                          <td>{{Activity.isCurrent}}</td>
                          <td>{{Activity.isPublished}}</td>
                          <td>{{Activity.creationDate}}</td>
                        </tr>
                        <tr *ngIf="WorkflowActivityPagingResult.length == 0">
                          <td colspan="4">
                            <lib-empty-data></lib-empty-data>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--end::Permission list-->
                </div>
                <div class="card-footer border-0">
                  <BBSF-Paging (Items)="setWorkflowActivityListResult($event)" *ngIf="IsFilterLoaded"
                               [options]="WorkflowActivityPaging" [group]="WorkflowActivityForm"
                               #WorkflowActivityPagingViewElement>
                  </BBSF-Paging>
                </div>
                <!--end:: Widgets/Applications/User/Profile3-->
              </div>
            </ng-template>
          </li>
          <li ngbNavItem class="nav-item mt-2">
            <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5" (click)="LoadWorkflowVariables()">{{utilityService.getResourceValue("WorkflowVariables")}}</a>
            <ng-template ngbNavContent>
              <div class="card">
                <div class="card-header border-0 pt-5 px-0">
                  <div class="card-title align-items-start flex-column">
                    <div class="filter-container text-dark"
                         *ngIf="IsWorkflowVariableFilterLoaded">
                      <form [formGroup]="WorkflowVariableForm">
                        <BBSF-TextBox [options]="WorkflowVariablesearchTextBox"
                                      [group]="WorkflowVariableForm"></BBSF-TextBox>
                        <BBSF-TextBox [options]="VerisonIdTextBox"
                                      [group]="WorkflowVariableForm" [hidden]="true"></BBSF-TextBox>
                      </form>
                    </div>
                  </div>
                  <div class="card-toolbar">
                    <button type="button" title="Add" class="btn btn-primary btn-sm"
                            (click)="showAddWorkflowVariableModal(AddWorkflowVariableModal)">
                      <i class=" fa fa-plus"></i> {{utilityService.getResourceValue("Add")}}
                    </button>
                  </div>
                </div>
                <div class="card-body py-3 px-0">
                  <!--begin::Permission list-->
                  <div class="table-responsive">
                    <!-- begin::Table -->
                    <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                      <thead>
                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">

                          <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                          <th *ngIf="!ProductionMode" class="min-w-150px">{{utilityService.getResourceValue("SysName")}}</th>
                          <th class="min-w-150px">{{utilityService.getResourceValue("DataType")}}</th>
                          <th class="min-w-150px">{{utilityService.getResourceValue("VariableType")}}</th>
                          <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>


                        </tr>
                      </thead>
                      <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

                        <tr *ngFor="let WorkflowVariable of WorkflowVariablePagingResult">

                          <td>
                            <a *ngIf="language=='en'" href="javascript:void(0)"
                               class="text-dark">{{WorkflowVariable.name.english}}</a>
                            <a *ngIf="language=='ar'" href="javascript:void(0)"
                               class="text-dark">{{WorkflowVariable.name.arabic}}</a>

                          </td>

                          <td *ngIf="!ProductionMode">
                            {{WorkflowVariable.sysName}}
                          </td>
                          <td>{{WorkflowVariable.dataTypeItem}}</td>
                          <td>{{WorkflowVariable.variableTypeItem}}</td>

                          <td>
                            <a class="btn btn-sm btn-light-primary btn-icon"
                               (click)="showEditWorkflowVariableModal(WorkflowVariable, EditWorkflowVariableModal)">
                              <i class="fa fa-edit"
                                 aria-hidden="true"></i>
                            </a>

                          </td>
                        </tr>
                        <tr *ngIf="WorkflowVariablePagingResult.length == 0">
                          <td [attr.colspan]="ProductionMode ? '4' : '5'">
                            <lib-empty-data></lib-empty-data>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--end::Permission list-->
                </div>
                <div class="card-footer border-0">
                  <BBSF-Paging (Items)="setWorkflowVariableListResult($event)"
                               *ngIf="IsWorkflowVariableFilterLoaded" [options]="WorkflowVariablePaging"
                               [group]="WorkflowVariableForm" #WorkflowVariablePagingViewElement>
                  </BBSF-Paging>
                </div>
                <!--end:: Widgets/Applications/User/Profile3-->
              </div>
              <!-- Add Modal -->
              <ng-template #AddWorkflowVariableModal let-modal>
                <div class="modal-header pb-0 border-0 justify-content-end">
                  <h5 class="modal-title" id="exampleModalLabel"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
                    <span class="svg-icon svg-icon-1">
                      <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
                    </span>
                  </button>
                </div>
                <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                  <div class="mb-13 text-center">
                    <h1 class="mb-3">
                      {{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("WorkflowVariable")}}
                    </h1>
                  </div>

                  <form [formGroup]="AddWorkflowVariableForm"
                        (ngSubmit)="addWorkflowVariable()">
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="NameInEnglish"
                                      [group]="AddWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="NameInArabic"
                                      [group]="AddWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row" *ngIf="!ProductionMode">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="SysNameWorkflowVariable"
                                      [group]="AddWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-DropdownList [options]="DataType"
                                           [group]="AddWorkflowVariableForm">
                        </BBSF-DropdownList>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-Toggleslide [options]="Constant"
                                          [group]="AddWorkflowVariableForm">
                        </BBSF-Toggleslide>
                      </div>
                    </div>
                    <div class="text-center pt-7">
                      <button #CloseWorkflowVariableModal id="CloseWorkflowVariableModal" type="button" class="btn btn-light me-3 btn-sm"
                              (click)="modal.dismiss()">
                        {{utilityService.getResourceValue("CancelLabel")}}
                      </button>
                      <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
                    </div>
                  </form>
                </div>
              </ng-template>
       
              <!--Edit Modal-->
              <ng-template #EditWorkflowVariableModal let-modal>
                <div class="modal-header pb-0 border-0 justify-content-end">
                  <h5 class="modal-title" id="exampleModalLabel"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
                    <span class="svg-icon svg-icon-1">
                      <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
                    </span>
                  </button>
                </div>
                <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                  <div class="mb-13 text-center">
                    <h1 class="mb-3">
                      {{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("WorkflowVariable")}}
                    </h1>
                  </div>
                  <form [formGroup]="EditWorkflowVariableForm"
                        (ngSubmit)="editWorkflowVariable()">
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditNameInEnglish"
                                      [group]="EditWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditNameInArabic"
                                      [group]="EditWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row" *ngIf="!ProductionMode">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditSysNameWorkflowVariable"
                                      [group]="EditWorkflowVariableForm">
                        </BBSF-TextBox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-DropdownList [options]="EditDataType"
                                           [group]="EditWorkflowVariableForm">
                        </BBSF-DropdownList>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-Toggleslide [options]="EditConstant"
                                          [group]="EditWorkflowVariableForm">
                        </BBSF-Toggleslide>
                      </div>
                    </div>



                    <div class="text-center pt-7">
                      <button #CloseEditWorkflowVariableModal id="CloseEditWorkflowVariableModal" type="button"
                              class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
                        {{utilityService.getResourceValue("CancelLabel")}}
                      </button>
                      <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
                    </div>
                  </form>
                </div>
              </ng-template>

            </ng-template>
          </li>
          <li ngbNavItem class="nav-item mt-2">
            <a ngbNavLink class="nav-link text-active-primary ms-0 me-10 py-5"  (click)="LoadworkflowActivity()">
              {{utilityService.getResourceValue("WorkflowActivities")}}
            </a>
            <ng-template ngbNavContent>
              <div class="card">
                <div class="card-header border-0 pt-5 px-0">
                  <div class="card-title align-items-start flex-column">
                    <div class="filter-container text-dark"
                         *ngIf="IsworkflowActivityFilterLoaded">
                      <form [formGroup]="workflowActivityForm">
                        <div id="filtersContainer" data-isloaded="true">
                          <BBSF-TextBox [options]="WorkflowActivityIdTextBox"
                                        [group]="workflowActivityForm" [hidden]="true"></BBSF-TextBox>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="card-toolbar">
                    <button type="button" title="Add" class="btn btn-primary btn-sm"
                            (click)="showAddworkflowActivityModal(AddWorkflowActivityModal)">
                      <i class="fa fa-plus"></i> {{utilityService.getResourceValue("Add")}} 

                    </button>
                  </div>
                </div>
                <div class="card-body py-3 px-0">
                  <div class="row">
                    <div class="col-lg-6 mb-8" *ngFor="let workflowActivity of ActivityPagingResult">
                      <div class="card bg-light-dark rounded">
                        <div class="card-header border-0 pt-9">
                          <div class="card-title m-0 fs-2 text-primary">
                            {{workflowActivity.typeName.current}}
                          </div>
                          <div class="card-toolbar">
                            <button type="button" id="btnAdd"
                                    class="btn btn-primary btn-sm me-2 ">
                              <i class="fa fa-gear" aria-hidden="true">
                                {{utilityService.getResourceValue("WorkflowVariables")}}
                              </i>
                            </button>
                            <button *ngIf="workflowActivity.isPublished" type="button"
                                    id="btnAdd"
                                    class="btn btn-light-primary btn-sm btn-icon me-2"
                                    (click)="showEditworkflowActivityModal(workflowActivity, EditWorkflowActivityModal)">
                              <i class="fas fa-pen"></i>
                            </button>
                            <button type="button" *ngIf="!workflowActivity.isPublished"
                                    id="btnAdd"
                                    class="btn btn-light-primary btn-sm btn-icon me-2"
                                    (click)="showEditworkflowActivityModal(workflowActivity,EditWorkflowActivityModal)">
                              <i class="fas fa-pen" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        <div class="card-body p-9">
                          <div class="fs-6 fw-bolder text-dark">{{utilityService.getResourceValue("WFOutcome")}}</div>
                          <div class="text-gray-400 fw-bold fs-5 mt-1 mb-7">
                            <ul class="list-unstyled">

                              <li>
                                {{utilityService.getResourceValue("WorkflowVariables")}}
                                <ul id="horizontalmenu">
                                  <li class="text-dark" *ngFor="let item of workflowActivity.variables">
                                    <i class="fa fa-gear"></i>
                                    {{item.sysName}}

                                  </li>
                                </ul>
                              </li>

                            </ul>
                          </div>

                          <div class=" mb-5">
                            <div *ngFor="let item of workflowActivity.outcomes">
                              {{ item.nameEN }}: {{item.nextActvityName}}
                            </div>
                          </div>
                        </div>
                        <!--end:: Card body-->

                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer border-0">
                  <BBSF-Paging (Items)="setActivityListResult($event)"
                               *ngIf="IsworkflowActivityFilterLoaded" [options]="ActivityPaging"
                               [group]="workflowActivityForm" #ActivityPagingViewElement>
                  </BBSF-Paging>
                </div>
                <!--end:: Widgets/Applications/User/Profile3-->
              </div>
              <!-- Add Modal -->
              <ng-template #AddWorkflowActivityModal let-modal>
                <div class="modal-header pb-0 border-0 justify-content-end">
                  <h5 class="modal-title" id="exampleModalLabel"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
                    <span class="svg-icon svg-icon-1">
                      <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
                    </span>
                  </button>
                </div>
                <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                  <div class="mb-13 text-center">
                    <h1 class="mb-3">
                      {{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("WorkflowActivity")}}

                    </h1>
                  </div>

                  <form [formGroup]="AddworkflowActivityForm"
                        (ngSubmit)="addworkflowActivity()">
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="workflowActivityNameInEnglish"
                                      [group]="AddworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="workflowActivityNameInArabic"
                                      [group]="AddworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="workflowActivityDescriptionInEnglish"
                                      [group]="AddworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="workflowActivityDescriptionInArabic"
                                      [group]="AddworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>

                    <div class="row" *ngIf="!ProductionMode">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="workflowActivitySysName"
                                      [group]="AddworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-DropdownList [options]="ActivityType"
                                           [group]="AddworkflowActivityForm">
                        </BBSF-DropdownList>
                      </div>
                    </div>

                    <div class="text-center pt-7">
                      <button #CloseworkflowActivityModal id="CloseworkflowActivityModal" type="button" class="btn btn-light me-3 btn-sm"
                              (click)="modal.dismiss()">
                        {{utilityService.getResourceValue("CancelLabel")}}
                      </button>
                      <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
                    </div>
                  </form>
                </div>
              </ng-template>



            
              <!--Edit Modal-->
              <ng-template #EditWorkflowActivityModal let-modal>
                <div class="modal-header pb-0 border-0 justify-content-end">
                  <h5 class="modal-title" id="exampleModalLabel"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
                    <span class="svg-icon svg-icon-1">
                      <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
                    </span>
                  </button>
                </div>
                <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                  <div class="mb-13 text-center">
                    <h1 class="mb-3">
                      {{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("WorkflowActivity")}}
                    </h1>
                  </div>
                  <form [formGroup]="EditworkflowActivityForm"
                        (ngSubmit)="editworkflowActivity()">
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditworkflowActivityNameInEnglish"
                                      [group]="EditworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditworkflowActivityNameInArabic"
                                      [group]="EditworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditworkflowActivityDescriptionInEnglish"
                                      [group]="EditworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditworkflowActivityDescriptionInArabic"
                                      [group]="EditworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>

                    </div>
                    <div class="row" *ngIf="!ProductionMode">
                      <div class="col-md-12">
                        <BBSF-TextBox [options]="EditworkflowActivitySysName"
                                      [group]="EditworkflowActivityForm">
                        </BBSF-TextBox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <BBSF-DropdownList [options]="EditActivityType"
                                           [group]="EditworkflowActivityForm">
                        </BBSF-DropdownList>
                      </div>
                    </div>

                    <div class="text-center pt-7">
                      <button #CloseEditworkflowActivityModal id="CloseEditworkflowActivityModal" type="button"
                              class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
                        {{utilityService.getResourceValue("CancelLabel")}}
                      </button>
                      <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
                    </div>
                  </form>
                </div>
              </ng-template>

            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  
  </div>

